performance.mark("appLoadStart");

import "./logger-init";
import { configureSalesTools } from "@expert/sales-tools";
import { createRoot } from "react-dom/client";

import { registerFeatureFlagReporter } from "./analytics";
import App from "./App";

// Before the first render, so no flag read happens before the reporter is installed.
registerFeatureFlagReporter();
configureSalesTools({ isProd: import.meta.env.VITE_ENV_TYPE === "production" });
import { enableDynatraceSessionReplay } from "./utils/RealUserMonitoringClient";

enableDynatraceSessionReplay();

const container = document.getElementById("root");
if (container === null) throw new Error("root element not found");

const root = createRoot(container);
root.render(<App />);
